import { Component, OnInit } from '@angular/core';
import { VoiceRecognitionService } from '../../services/voice-recognition.service';
import { Location } from '@angular/common';
import { ServiceService } from '../../services/service.service';

@Component({
  selector: 'app-speech-to-text',
  templateUrl: './speech-to-text.component.html',
  styleUrls: ['./speech-to-text.component.scss'],
  providers: [VoiceRecognitionService]
})
export class SpeechToTextComponent implements OnInit {
  text: string = '';
  constructor(
    private _location: Location, public VoiceRecognitionService: VoiceRecognitionService, private _service: ServiceService) { }

  ngOnInit(): void {
    this._service.getText().subscribe(result => {
      this.text = result;
    });
  }

  goBack(){
    this._location.back();
  }


}